import { render, staticRenderFns } from "./RoleEditPopup.vue?vue&type=template&id=5f9beb20&"
import script from "./RoleEditPopup.vue?vue&type=script&lang=js&"
export * from "./RoleEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports